import * as React from 'react';

import { useImmerReducer } from 'use-immer';

type Open = {
  type: 'open';
  payload: { confirmAction: () => void; selectedItemCount: number };
};

type Close = {
  type: 'close';
};

type DialogAction = Open | Close;

export interface PurgeQuizFolderConfirmationState {
  isOpen: boolean;
  selectedItemCount: number;
  confirmAction: () => void;
}

export type PurgeDialogDispatch = React.Dispatch<DialogAction>;

function dialogReducer(
  draft: PurgeQuizFolderConfirmationState,
  action: DialogAction
) {
  switch (action.type) {
    case 'open': {
      const { confirmAction, selectedItemCount } = action.payload;
      draft.isOpen = true;
      draft.confirmAction = confirmAction;
      draft.selectedItemCount = selectedItemCount;
      break;
    }
    case 'close': {
      draft.isOpen = false;
      draft.confirmAction = () => {
        /* empty */
      };
      draft.selectedItemCount = 0;
      break;
    }
    default: {
      draft.isOpen = false;
      draft.confirmAction = () => {
        /* empty */
      };
      draft.selectedItemCount = 0;
      break;
    }
  }
}

export function usePurgeDialog() {
  return useImmerReducer(dialogReducer, {
    isOpen: false,
    selectedItemCount: 0,
    confirmAction: () => {
      /* empty */
    },
  });
}
